import { Quote } from "lucide-react";
import { PageShell } from "../components/layout/PageShell";
import { CtaBand } from "../components/layout/CtaBand";
import { REVIEWS } from "../data/reviews";

const CATEGORIES = ["Dog Walking", "Pet Sitting", "Cats & Home Visits"];

export default function ReviewsPage() {
  return (
    <PageShell title="Reviews">
      <section className="pt-20 pb-10 sm:pt-28 sm:pb-14" data-testid="reviews-hero">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <p className="eyebrow">Reviews</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-medium text-[#292A26] tracking-tight mt-4 max-w-3xl" data-testid="reviews-page-heading">
            Kind words.
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg leading-relaxed text-[#575953]">
            The best part of Mary Pawpins is getting to know the animals and the people
            behind them. Here are a few words from clients who have trusted Carly with
            their pets.
          </p>
        </div>
      </section>

      {CATEGORIES.map((cat) => (
        <section key={cat} className="py-8 sm:py-10" data-testid={`reviews-${cat.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
          <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
            <h2 className="font-serif text-2xl sm:text-3xl font-medium text-[#292A26] tracking-tight">{cat}</h2>
            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {REVIEWS.filter((r) => r.service === cat).map((r) => (
                <figure key={r.id} className="bg-white rounded-3xl border border-[#DDD7CB] p-7 flex flex-col" data-testid={`review-${r.id}`}>
                  <Quote className="w-5 h-5 text-[#D8B7B0]" />
                  <blockquote className="mt-4 text-sm leading-relaxed text-[#292A26] flex-1">{r.text}</blockquote>
                  <figcaption className="mt-5 pt-4 border-t border-[#E7E2D8]">
                    <p className="text-sm font-semibold text-[#292A26]">{r.attribution}</p>
                    <p className="text-xs text-[#575953]">{r.relation} · {r.source}</p>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </section>
      ))}

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 mt-6">
        <p className="text-xs text-[#575953] max-w-2xl italic">
          Genuine reviews shared by Mary Pawpins clients on Google and Facebook, reproduced with their wording intact.
        </p>
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 mt-8">
        <div className="rounded-3xl bg-[#E7E2D8]/60 border border-[#DDD7CB] p-8 sm:p-10 text-center" data-testid="leave-review-section">
          <h2 className="font-serif text-2xl font-medium text-[#292A26]">Had a good experience?</h2>
          <p className="mt-2 text-sm text-[#575953] max-w-md mx-auto">
            An honest review helps other local owners find care they can trust. It takes two minutes and means a lot.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <a
              href="https://share.google/6Fz6qll6PwQpYXOyr"
              target="_blank" rel="noopener noreferrer"
              data-testid="leave-review-google"
              className="inline-flex items-center gap-2 rounded-full bg-[#3F4A38] text-[#F7F4ED] px-6 py-3 text-sm font-semibold hover:bg-[#2F382B] transition-colors"
            >
              Review on Google
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61586003890175"
              target="_blank" rel="noopener noreferrer"
              data-testid="leave-review-facebook"
              className="inline-flex items-center gap-2 rounded-full border border-[#3F4A38]/40 text-[#3F4A38] px-6 py-3 text-sm font-semibold hover:bg-[#3F4A38] hover:text-[#F7F4ED] transition-colors"
            >
              Review on Facebook
            </a>
          </div>
        </div>
      </div>

      <CtaBand
        testId="reviews-cta"
        heading="Ready to get acquainted?"
        copy="If you are looking for someone to care for your pet, Carly would be happy to hear from you."
      />
    </PageShell>
  );
}
